import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';

const DAYS = [
  {
    key: 'Sunday',
    label: 'S',
  },
  {
    key: 'Monday',
    label: 'M',
  },
  {
    key: 'Tuesday',
    label: 'T',
  },
  {
    key: 'Wednesday',
    label: 'W',
  },
  {
    key: 'Thursday',
    label: 'T',
  },
  {
    key: 'Friday',
    label: 'F',
  },
  {
    key: 'Saturday',
    label: 'S',
  },
];

const styles = {
  styledToggleButtonGroup: {
    '.MuiToggleButtonGroup-grouped': {
      mx: 1.5,
      mt: 1,
      mb: 2,
      px: 1,
      py: 0,
      '&:not(:last-of-type)': {
        border: 1,
        borderColor: 'primary.dark',
        borderRadius: '50%',
        ml: 0,
      },
      '&:not(:first-of-type)': {
        border: 1,
        borderColor: 'primary.dark',
        borderRadius: '50%',
        ml: 0,
      },
      '&:first-of-type': {
        border: 1,
        borderColor: 'primary.dark',
        borderRadius: '50%',
      },
    },
  },
  styledToggle: {
    '&.MuiToggleButton-root': {
      color: 'primary.main',
      width: '2rem',
      height: '2rem',
      fontSize: '0.75rem',
      '&:selected': {
        color: 'white',
        bgcolor: 'primary.main',
      },
      '&:hover': {
        color: 'white',
        borderColor: 'primary.light',
        bgcolor: 'primary.light',
      },
      '&:hover$selected': {
        borderColor: 'primary.light',
        bgcolor: 'primary.light',
      },
      '&:not($selected, hover)': {
        border: 1,
        borderColor: 'primary.main',
        borderRadius: '50%',
      },
    },
    '&.Mui-selected': {
      color: 'white',
      bgcolor: 'primary.main',
      border: 1,
    },
  },
};

function DaysSelector({ value, onChange, name, classes }) {
  return (
    <ToggleButtonGroup
      fullWidth
      orientation="horizontal"
      size="small"
      arial-label="Days schedule repeat"
      value={value}
      onChange={onChange}
      sx={{ ...styles.styledToggleButtonGroup }}
    >
      {DAYS.map((day, index) => (
        <Tooltip
          placement="top"
          title={day.key}
          value={index}
          key={day.key}
          sx={{ ...classes.tooltip }}
        >
          <ToggleButton
            key={day.key}
            value={index}
            aria-label={day.key}
            name={name}
            sx={{ ...styles.styledToggle }}
          >
            {day.label}
          </ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
}

export default DaysSelector;
